"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotificationUtils = exports.NotificationUtils = function () {
    function NotificationUtils(history) {
        _classCallCheck(this, NotificationUtils);

        this._history = history;
    }

    _createClass(NotificationUtils, [{
        key: "bind",
        value: function bind(el) {
            this._reactNotificationSystem = el;
        }
    }, {
        key: "showNotification",
        value: function showNotification(notification) {
            this._reactNotificationSystem && this._reactNotificationSystem.addNotification(notification);
        }
    }, {
        key: "showNotificationAndRedirect",
        value: function showNotificationAndRedirect(url, notification) {
            var _this = this;

            var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref$reloadPage = _ref.reloadPage,
                reloadPage = _ref$reloadPage === undefined ? false : _ref$reloadPage,
                _ref$redirectDelay = _ref.redirectDelay,
                redirectDelay = _ref$redirectDelay === undefined ? 1000 : _ref$redirectDelay;

            this.showNotification(notification);

            setTimeout(function () {
                _this._history.push(url);
                reloadPage && window.location.reload();
            }, redirectDelay);
        }
    }]);

    return NotificationUtils;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/notification/NotificationUtils.js
// module id = 1327
// module chunks = 118